import { StyleSheet } from 'react-native'
import HelperPlatform from 'utils/helper-platform'

export const IconBackgroundStyles = StyleSheet.create({
	container: {
		overflow: 'hidden',
		...HelperPlatform.select({
			native: {
				flex: 0
			},
			web: {
				flex: undefined
			}
		})
	},
	
	backgroundContainer: {
		overflow: 'hidden',
		...HelperPlatform.select({
			native: {
				flex: 0
			},
			web: {
				flex: undefined
			}
		})
	},
	
	gradientOverlay: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		opacity: 0.85,
		width: '100%',
		height: '100%',
	}
});
